/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Modal, Stack, TextArea } from '@carbon/react';
import { useRef } from 'react';
import { createPortal } from 'react-dom';

import reviewStore from 'App/Pages/ProcessApplicationVersions/features/review/ReviewStore';
import Description from 'App/Pages/ProcessApplicationVersions/features/review/perform-review/Description';
import { SelfReviewWarning } from 'App/Pages/ProcessApplicationVersions/features/review/perform-review/SelfReviewWarning';

export default function ApproveModal({ open, closeModal, versionId, isAdminSelfReview }) {
  const commentRef = useRef(null);

  return createPortal(
    <Modal
      open={open}
      onRequestClose={closeModal}
      modalHeading="Approve changes"
      preventCloseOnClickOutside
      primaryButtonText="Approve changes"
      secondaryButtonText="Cancel"
      onRequestSubmit={async () => {
        const comment = commentRef?.current?.value;
        await reviewStore.approve(versionId, comment);
        closeModal();
      }}
    >
      <Stack gap={2}>
        {isAdminSelfReview && <SelfReviewWarning />}
        <Description>
          You are going to approve a review for an entire process application. Make sure to review all files that
          contain changes.
        </Description>
        <TextArea
          data-modal-primary-focus
          labelText="Comment (optional)"
          placeholder="Add your comment here..."
          ref={commentRef}
        />
      </Stack>
    </Modal>,
    document.body
  );
}
